import moment from "moment";

export const COMPARED_STATUS = {
  PENDING: "pending",
  PROCESSING: "processing",
  COMPLETED: "completed",
  FAILED: "failed",
};

// Thresholds for "good" metrics (higher is better), in percent
const GOOD_THRESHOLD = 90;
const WARN_THRESHOLD = 70;

export function getLevel(percent) {
  if (!Number.isFinite(percent)) return "none";
  if (percent >= GOOD_THRESHOLD) return "good";
  if (percent >= WARN_THRESHOLD) return "warn";
  return "bad";
}

// Missing / redundant: lower is better, so invert before grading
export function getInverseLevel(percent) {
  if (!Number.isFinite(percent)) return "none";
  return getLevel(100 - percent);
}

export function formatPercent(value) {
  if (!Number.isFinite(value)) return "-";
  return `${Number(value.toFixed(2))}%`;
}

export function formatDate(date) {
  return date ? moment(date).format("DD/MM/YYYY HH:mm") : "-";
}

// labelId is a number in compareResult but a string in labelingData
export function isSameId(a, b) {
  return String(a) === String(b);
}

export function sortByCreatedDateDesc(histories = []) {
  return [...histories].sort(
    (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
  );
}

// A submitted snapshot is compared against the two higher review levels.
// Order = display priority (groundTruthId first).
const COMPARISON_DEFS = [
  {
    key: "doublecheck",
    title: "Double-check",
    short: "DC",
    statusKey: "comparedStatus",
    dateKey: "comparedDate",
    groundTruthKey: "groundTruthId",
    resultKey: "compareResult",
  },
  {
    key: "approved",
    title: "Approved",
    short: "AP",
    statusKey: "approvedComparedStatus",
    dateKey: "approvedComparedDate",
    groundTruthKey: "approvedGroundTruthId",
    resultKey: "approvedCompareResult",
  },
];

// Only comparisons that have a ground truth to compare against
export function getComparisons(history) {
  if (!history) return [];
  return COMPARISON_DEFS.filter((def) => history[def.groundTruthKey]).map(
    (def) => ({
      key: def.key,
      title: def.title,
      short: def.short,
      status: history[def.statusKey],
      date: history[def.dateKey],
      groundTruthId: history[def.groundTruthKey],
      result: history[def.resultKey],
    })
  );
}

export function isComparisonReady(comparison) {
  return (
    comparison?.status === COMPARED_STATUS.COMPLETED &&
    !!comparison.result?.overall
  );
}

export function getUserName(history) {
  if (history?.userInfo?.fullName) return history.userInfo.fullName;
  return history?.createdBy ? `User #${history.createdBy}` : "-";
}
